import React from 'react';
import PropTypes from 'prop-types';
import { has, get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { Image } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  margin: 0 0 30px 0;
  .PlanCard_wrapper {
    display: flex;
  }
  .PlanCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
  }
  .PlanCard_media {
    img {
      width: 100%;
      height: auto;
    }
  }
  .PlanCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${colors.color4};
    padding: 0 15px;
    h4 {
      padding: 18px 5px 10px 5px;
      margin: 0;
      border-bottom: 2px solid ${colors.color4Darkest};
    }
    h4 a {
      color: ${colors.color5};
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
      margin: 0;
      display: block;
      transition: all .3s ease;
      &:hover {
        color: ${colors.color2};
      }
    }
  }
  .PlanCard_iconList {
    display: flex;
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0;
    li {
      border-right: 2px solid ${colors.color4Darkest};
      width: 25%;
      text-align: center;
      padding: 12px 0;
      font-size: 14px;
      font-weight: 300;
      line-height: 18px;
      & > span {
        display: block;
      }
      &:last-child {
        border: 0;
      }
      .PlanCard_iconListIcon {
        margin: 0 0 4px 0;
      }
      .PlanCard_iconListValue {
        font-weight: 700;
        font-size: 16px;
      }
      .lighter {
        font-weight: 400;
      }
      a {
        color: ${colors.color5};
        font-weight: 700;
        transition: all .3s ease;
        &:hover {
          color: ${colors.color2};
        }
      }
      .PlanCard_linkIcon {
        width: 18px;
        height: 18px;
        margin: 5px 0 0 0;
      }
    }
  }
  .PlanCard_buttonWrapper {
    display: flex;
    justify-content: flex-end;
    margin: 0;
  }
  .PlanCard_mapButton {
    width: 40px;
    height: 40px;
    background-color: #6C6C6C;
    background-image: url('/images/icon-map-pin-white.svg');
    background-position: center center;
    background-repeat: no-repeat;
  }
  .PlanCard_detailButton {
    flex-grow: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: ${colors.color2};
    color: #FFFFFF;
    font-weight: 700;
    font-size: 15px;
  }
`;

function PlanCard({ plan, widget }) {
  const background = {};
  if (has(plan, 'elevationPhotos[0].contentUrl')) {
    background.backgroundImage = get(plan, 'elevationPhotos[0].contentUrl');
  } else {
    background.backgroundImage = get(widget, 'default_image.contentUrl');
  }
  return (
    <div className={styles}>
      <div className="PlanCard_wrapper">
        <div className="PlanCard_inner">
          <div className="PlanCard_media">
            <Link name="plan-detail" plan={plan}>
              <Image
                src={background.backgroundImage}
                alt={get(plan, 'name')}
                width={475}
                height={250}
                exact
              />
            </Link>
          </div>
          <div className="PlanCard_content">
            <h4>
              <Link name="plan-detail" plan={plan}>
                {get(plan, 'name')}
              </Link>
            </h4>
            <ul className="PlanCard_iconList">
              {
                get(plan, 'beds') &&
                <li>
                  <span className="PlanCard_iconListIcon"><img src="/images/icon-beds.svg" alt="" /></span>
                  <span className="PlanCard_iconListValue">{get(plan, 'beds')}</span>
                  <span className="PlanCard_iconListLabel">Beds</span>
                </li>
              }
              {
                get(plan, 'bathsFull') &&
                <li>
                  <span className="PlanCard_iconListIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                  <span className="PlanCard_iconListValue">
                    <span>{get(plan, 'bathsFull') + (get(plan, 'bathsHalf', 0) * 0.5)}</span>
                  </span>
                  <span className="PlanCard_iconListLabel">Baths</span>
                </li>
              }
              {
                get(plan, 'sqft') &&
                <li>
                  <span className="PlanCard_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                  <span className="PlanCard_iconListValue">{numeral(get(plan, 'sqft')).format('0,0')}</span>
                  <span className="PlanCard_iconListLabel">SQ FT</span>
                </li>
              }
              <li>
                <Link name="plan-detail" plan={plan}>
                View<br />Details<br />
                  <img src="/images/icon-arrow-gold.svg" className="PlanCard_linkIcon" alt="" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

PlanCard.propTypes = {
  plan: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  plan: true,
  widget: 'default_image',
})(PlanCard);



// WEBPACK FOOTER //
// ./src/components/PlanCard.js